import {
  initializeSslPinning,
  isSslPinningAvailable,
} from 'react-native-ssl-public-key-pinning';
import { logInfo } from './logHandling';

/**
 *  This starts the SSL pinning to trust only our public key for all requests to app.neolexon.de
 * @returns {Promise<void>}
 */
async function initSSLPinning() {
  if (!isSslPinningAvailable()) {
    logInfo('SSL Pinning is not available for this platform');
  } else {
    await initializeSslPinning({
      'app.neolexon.de': {
        includeSubdomains: true,
        publicKeyHashes: [
          'rftGJB1Ab+s2IQ0fY5o7gL12GJ0G4UpNB1zJUsNHGY8=',
          'iKzGYWr+RofnXxuLLEkq67090hkiKGffvrn2tQ/Xja4=', // backup1 2048 RSA key
          '+hqlq48TWB6i7p7bD14eo2VHWshMCLypWVN2mdwIqZw=', // backup2 2048 RSA key
          'TyL2nU7DeyOD5kqGJPwnxzxp3k46+9CgsON0pnZMreA=', // backup3 4096 RSA key
          'cqTVzjrOKJaVhKdaWcEzmop1EElquUTI7vb1zs3gXBs=', // backup4 4096 RSA key
        ],
      },
      'app-staging.neolexon.de': {
        includeSubdomains: true,
        publicKeyHashes: [
          'rftGJB1Ab+s2IQ0fY5o7gL12GJ0G4UpNB1zJUsNHGY8=',
          'iKzGYWr+RofnXxuLLEkq67090hkiKGffvrn2tQ/Xja4=', // backup1 2048 RSA key
          '+hqlq48TWB6i7p7bD14eo2VHWshMCLypWVN2mdwIqZw=', // backup2 2048 RSA key
          'TyL2nU7DeyOD5kqGJPwnxzxp3k46+9CgsON0pnZMreA=', // backup3 4096 RSA key
          'cqTVzjrOKJaVhKdaWcEzmop1EElquUTI7vb1zs3gXBs=', // backup4 4096 RSA key
        ],
      },
      'app-bsi.neolexon.de': {
        includeSubdomains: true,
        publicKeyHashes: [
          'rftGJB1Ab+s2IQ0fY5o7gL12GJ0G4UpNB1zJUsNHGY8=',
          'iKzGYWr+RofnXxuLLEkq67090hkiKGffvrn2tQ/Xja4=', // backup1 2048 RSA key
          '+hqlq48TWB6i7p7bD14eo2VHWshMCLypWVN2mdwIqZw=', // backup2 2048 RSA key
          'TyL2nU7DeyOD5kqGJPwnxzxp3k46+9CgsON0pnZMreA=', // backup3 4096 RSA key
          'cqTVzjrOKJaVhKdaWcEzmop1EElquUTI7vb1zs3gXBs=', // backup4 4096 RSA key
        ],
      },
    });
    // uncomment to test the pinning in the console
    /* axios.get('https://app-staging.neolexon.de').then(function () {
             console.log('success');
         }, function (err) {
             console.log('err:' + err.message);
         });*/
  }
}

let sslPinning = {
  init: initSSLPinning,
};
export default sslPinning;
